import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@systemeio/ui';
import { ChevronDownIcon } from '@systemeio/ui/icons';
import { TopMenuSubItem } from 'shared/components/header/components/desktop-menu/components/desktop-menu-item';
import { pageRoute } from 'shared/constants/routes.constants';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePermission } from 'shared/hooks/use-permission';
import { useRouter } from 'shared/hooks/use-router';
import useUser from 'shared/hooks/use-user';
import { twMerge } from 'tailwind-merge';
import { SubAccountSelector } from './sub-account-selector';
function Avatar() {
  const $ = _c(40);
  const {
    dashboardUser,
    isWorkspaceOwner,
    isLoading,
    isDisabled,
    isSupportImpersonation,
    avatarUrl
  } = useUser();
  const {
    pagePermissions
  } = usePermission();
  const {
    t
  } = useLocoTranslation();
  const {
    pathname
  } = useRouter();
  const shouldShowSubAccountPage = Boolean(pagePermissions[pageRoute.Subaccounts]);
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname.includes("/profile");
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const profileIsActive = t0;
  let t1;
  if ($[2] !== pathname) {
    t1 = pathname.includes("/subaccounts");
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const subaccountsIsActive = t1;
  if (isLoading) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="bg-text-secondary h-10 w-10 animate-pulse rounded-full" />;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (!dashboardUser) {
    return null;
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: -5
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isDisabled || $[7] !== isWorkspaceOwner || $[8] !== profileIsActive || $[9] !== shouldShowSubAccountPage || $[10] !== subaccountsIsActive || $[11] !== t) {
    t3 = !isDisabled && <>{isWorkspaceOwner && <li className="flex justify-center"><SubAccountSelector className="mx-3 my-1 w-48" /></li>}<TopMenuSubItem dataTestId="settings-link" name={t("global.settings")} href={isWorkspaceOwner ? "/profile/user-settings" : "/profile/account-settings"} isActive={() => profileIsActive} shouldRender={true} />{isWorkspaceOwner && <TopMenuSubItem name={t("header.user.profile.menu.sub_accounts")} href="/subaccounts" isActive={() => subaccountsIsActive} shouldRender={shouldShowSubAccountPage} />}<hr className="text-[rgb(var(--background-tertiary))] mx-5 my-1 px-4" /></>;
    $[6] = isDisabled;
    $[7] = isWorkspaceOwner;
    $[8] = profileIsActive;
    $[9] = shouldShowSubAccountPage;
    $[10] = subaccountsIsActive;
    $[11] = t;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t) {
    t4 = t("header.exit_impersonation");
    $[13] = t;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== isSupportImpersonation || $[16] !== t4) {
    t5 = <TopMenuSubItem shouldRender={isSupportImpersonation} isActive={_temp} name={t4} href="/back/entry?pretend_this_user=_exit" />;
    $[15] = isSupportImpersonation;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t3 || $[19] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[18] = t3;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t) {
    t7 = t("header.user.profile.menu.logout");
    $[21] = t;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t7) {
    t8 = <TopMenuSubItem shouldRender={true} isActive={_temp2} name={t7} href="/logout" />;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t6 || $[26] !== t8) {
    t9 = <><ul className="text-text-tertiary flex flex-col py-4 text-sm">{t6}{t8}</ul></>;
    $[25] = t6;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  const t10 = profileIsActive || subaccountsIsActive ? "border-brand-primary" : "border-transparent ";
  let t11;
  if ($[28] !== t10) {
    t11 = twMerge("focus-visible:border-brand-primary flex h-full items-center gap-2 border-b-4 focus:outline-hidden", t10);
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  const t12 = `${dashboardUser.firstName} ${dashboardUser.lastName}`;
  let t13;
  if ($[30] !== avatarUrl || $[31] !== t12) {
    t13 = <img className="h-10 w-10 overflow-hidden rounded-full object-cover" src={avatarUrl} alt={t12} data-test-id="top-menu-avatar" />;
    $[30] = avatarUrl;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <ChevronDownIcon />;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t11 || $[35] !== t13) {
    t15 = <div className={t11}>{t13}{t14}</div>;
    $[34] = t11;
    $[35] = t13;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t15 || $[38] !== t9) {
    t16 = <Tooltip anchor={t2} stayOnHover={true} mode="hover" popoverClassName="p-0 rounded-lg shadow-lg" wrapperClassName="h-[100%]" label={t9}>{t15}</Tooltip>;
    $[37] = t15;
    $[38] = t9;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  return t16;
}
function _temp2() {
  return false;
}
function _temp() {
  return false;
}
export default Avatar;